import type { UpdateCourseDraft200LocalizedSectionsItemLecturesItem } from './updateCourseDraft200LocalizedSectionsItemLecturesItem';

/**
 * 코스 섹션 정보
 */
export type UpdateCourseDraft200LocalizedSectionsItem = {
  /**
   * 섹션 ID (새 섹션의 경우 null)
   * @nullable
   */
  id?: string | null;
  /**
   * 섹션에 포함된 강의 목록
   * @nullable
   */
  lectures?: UpdateCourseDraft200LocalizedSectionsItemLecturesItem[] | null;
  /**
   * 섹션 순서 (1부터 시작)
   * @minimum 1
   */
  order: number;
  /**
   * 섹션 제목
   * @minLength 1
   * @maxLength 100
   */
  title: string;
};
